import { n as RepositoryDiscoveryService, r as RepositoryService, t as IGNORED_DIRECTORY_NAMES } from "./common_paths-B0_4d8JX.mjs";
import { n as GitLsFiles, r as isUnsupportedDircacheError, t as GitConfigCommand } from "./git_config-CLNchKNV.mjs";
import { tryParseUrl } from "@gitlab-org/core";
//#region src/git/utils/git_remote_parser.ts
/**
* GitLabRemote represents a parsed git remote URL that could potentially point to a GitLab project.
*/
const getInstancePath = (instanceUrl) => {
	const { pathname } = tryParseUrl(instanceUrl) || {};
	return pathname ? pathname.replace(/\/$/, "") : "";
};
const escapeForRegExp = (str) => str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
function normalizeSshRemote(remote) {
	const sshRemoteWithCustomPort = remote.match(`^\\[([a-zA-Z0-9_-]+@.*?):(\\d+)\\]:(.*)$`);
	if (sshRemoteWithCustomPort) return `ssh://${sshRemoteWithCustomPort[1]}:${sshRemoteWithCustomPort[2]}/${sshRemoteWithCustomPort[3]}`;
	const sshRemoteWithSchemeAndCustomPort = remote.match(`^ssh://([a-zA-Z0-9_-]+@.*?):(\\d+)(.*)$`);
	if (sshRemoteWithSchemeAndCustomPort) return `ssh://${sshRemoteWithSchemeAndCustomPort[1]}:${sshRemoteWithSchemeAndCustomPort[2]}${sshRemoteWithSchemeAndCustomPort[3]}`;
	const sshRemoteWithPortInPath = remote.match(`([a-zA-Z0-9_-]+@[^:]+):(\\d+)/(.*)$`);
	if (sshRemoteWithPortInPath) return `ssh://${sshRemoteWithPortInPath[1]}:${sshRemoteWithPortInPath[2]}/${sshRemoteWithPortInPath[3]}`;
	const sshRemoteWithPath = remote.match(`([a-zA-Z0-9_-]+@.*?):(.*)`);
	if (sshRemoteWithPath) return `ssh://${sshRemoteWithPath[1]}/${sshRemoteWithPath[2]}`;
	if (remote.match(`^[a-zA-Z0-9_-]+@`)) return `ssh://${remote}`;
	return remote;
}
async function tryParseRepositoryGitLabRemoteDetails(repository, gitlabInstanceUrl) {
	try {
		const remotes = await repository.listRemotes();
		const originRemote = remotes.find((r) => r.remote === "origin") ?? remotes[0];
		if (!originRemote?.url) return;
		return parseGitLabRemote(originRemote.url, gitlabInstanceUrl);
	} catch (error) {
		const errMessage = error instanceof Error ? error.message : String(error);
		throw new Error(`Failed to parse GitLab remotes from repository: ${errMessage}`);
	}
}
function parseGitLabRemote(remote, instanceUrl) {
	const { hostname, host, pathname } = tryParseUrl(normalizeSshRemote(remote)) || {};
	if (!host || !pathname) return;
	if (!(hostname === tryParseUrl(normalizeSshRemote(instanceUrl))?.hostname)) return;
	const pathRegExp = instanceUrl || instanceUrl.trim() !== "" ? escapeForRegExp(getInstancePath(instanceUrl)) : "";
	const match = pathname.match(`(?:${pathRegExp})?/:?(.+)/([^/]+?)(?:.git)?/?$`);
	if (!match) return;
	const [namespace, projectPath] = match.slice(1, 3);
	if (!namespace || !projectPath) return;
	return {
		host,
		namespace,
		projectPath,
		namespaceWithPath: `${namespace}/${projectPath}`
	};
}
//#endregion
export { GitConfigCommand, GitLsFiles, IGNORED_DIRECTORY_NAMES, RepositoryDiscoveryService, RepositoryService, isUnsupportedDircacheError, parseGitLabRemote, tryParseRepositoryGitLabRemoteDetails };

//# sourceMappingURL=index.mjs.map